import { request, language } from '@tencent/ppd-base-libs';
import { handleFormatRes } from '@tencent/wphk-act-base-cgi';
import { MainlandActConfig } from '../types';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import { getConfigWithLang } from '@tencent/wphk-base-utils';

dayjs.extend(isBetween);

export const loadConfig = async () => {
  const data = await request.loadConfig('//st.moneydata.hk/wuji/config/mainlandActConfig/mainlandActConfig.json');
  const formattedConfig = formatConfigType(data) as MainlandActConfig[];
  const validConfig = filterValidConfig(formattedConfig);
  return validConfig;
};

const formatConfigType = (config) => {
  const formattedTypeRes = handleFormatRes({
    result: { config },
    needParseDateKey: ['actStartDate', 'actEndDate'],
  });
  const formattedLangRes = getConfigWithLang(formattedTypeRes, language.getLanguage());
  return formattedLangRes.config.map((item) => {
    const formattedSpIdList = (item.spIdList || '').split(',');
    return { ...item, spIdList: formattedSpIdList };
  });
};

/** 筛选生效中的配置 */
const filterValidConfig = (config: MainlandActConfig[]) => {
  const curTime = dayjs(getServerTime());
  return config.filter((item) => {
    const { actEndDate, actStartDate } = item;
    const startTime = dayjs(actStartDate);
    const endTime = dayjs(actEndDate);
    return curTime.isBetween(startTime, endTime);
  });
};

/** url上的actType（如springAct)，校验一致才展示港人内地模块；如果为空，则不校验。 */
export const isValidActType = (
  config: MainlandActConfig,
  targetActType: string,
) => !config.actType || config.actType === targetActType;

/** 是否有对应的spid的配置 */
export const isTargetSpId = (
  config: MainlandActConfig,
  targetSpId: string,
) => config.spIdList.includes(targetSpId);
